import { express_services } from "./constants";

export function isFedex(r) {
  return r.ship_via && r.ship_via.slice(0, 5).toLowerCase() === "fedex";
}

export function isUps(r) {
  return r.ship_via && r.ship_via.slice(0, 3).toLowerCase() === "ups";
}

export function isExpress(r) {
  return express_services.includes(r.toUpperCase());
}

export function formatTrackingNumber(tracking_number) {
  return tracking_number.startsWith("1Z")
    ? tracking_number
    : tracking_number.length >= 12
    ? tracking_number.includes("61299999")
      ? tracking_number.substring(tracking_number.length - 20)
      : tracking_number.substring(tracking_number.length - 12)
    : tracking_number;
}

export const tracking_re = new RegExp(/(1ZV[0-9]{12,})|([0-9]{12,}|1Z(C|B|Y)[0-9|A-Z]{12,})/);

const billing_type_labels = {
  Sender: "Sender",
  Third_Party: "Third Party",
  Surepost: "SurePost",
};

// Which carrier account the label was billed to. Only set for labels created after
// the field was introduced, so older shipments render as "-".
export function formatBilling(shipment) {
  if (!shipment || !shipment.billing_type) return "-";
  const label = billing_type_labels[shipment.billing_type] || shipment.billing_type;
  return shipment.billing_account ? `${label} · ${shipment.billing_account}` : label;
}
